module.exports = __webpack_public_path__ + "img/ww.40265f65.png";